import sanityClient from "@sanity/client";
import imgUrlBuilder from "@sanity/image-url";

export const client = sanityClient({
  projectId: process.env.VUE_APP_SANITY_PROJECT_ID,
  dataset: process.env.NODE_ENV === "production" ? "production" : "development",
  ignoreBrowserTokenWarning: true,
  useCdn: process.env.NODE_ENV !== "development",
  apiVersion: "2021-11-04",
});

export const imageUrlBuilder = imgUrlBuilder(client);
